import { render, staticRenderFns } from "./Dente.vue?vue&type=template&id=b15d2640&scoped=true&"
import script from "./Dente.vue?vue&type=script&lang=js&"
export * from "./Dente.vue?vue&type=script&lang=js&"
import style0 from "./Dente.vue?vue&type=style&index=0&id=b15d2640&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d2640",
  null
  
)

export default component.exports